module.exports = __webpack_public_path__ + "static/media/mdisp32_1.215ed901.ico";